export default __webpack_public_path__ + "static/image-65-da0e91aae8e68a86c0ffbfa97ba2b05c.jpg";